import Grid from '@mui/material/Grid';
import React, {useEffect, useState} from 'react';
import {createMainScreenButtons} from '../util/mainScreenUtil';
import MainScreenButton from '../../../../components/forms/mainScreenButton';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {getConfig} from '../../../../util/configUtil';
import Typography from '@mui/material/Typography';
import {Divider} from '@mui/material';
import {useEventListener} from '../../../../hooks/useEventListener';
import {ctxPatientType, ctxSplitScreen, openPatientForm} from '../../../../store/reducers/patientContext';
import {PATIENT_CONTEXT_TYPE} from '../../../../util/patientContextUtil';

const MainScreenTaskButtons = ({patient, disableSave, container}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const patientType = useSelector(ctxPatientType);
    const splitScreen = useSelector(ctxSplitScreen);

    const [columnCount, setColumnCount] = useState('1fr 1fr 1fr');

    // Configs
    const nurseMedicalPlanAvailable = getConfig('nurseMedicalPlanAvailable', false);
    const treatmentFormEnabled = getConfig('treatmentFormEnabled', false);

    useEffect(() => {
        getColumnCount();
    }, [splitScreen?.enabled]);

    function getColumnCount() {
        const width = container?.offsetWidth ?? window.innerWidth;
        let columns = '1fr 1fr 1fr';
        if (width < 768) {
            columns = '1fr';
        } else if (width < 1118) {
            columns = '1fr 1fr';
        }
        setColumnCount(columns);
    }

    useEventListener('resize', getColumnCount);

    const getTreatmentPlanBtnColor = () => {
        const totalAmountOfNotes = patient?.studies?.treatmentPlan?.notes?.length;
        const amountOfCheckedNotes = patient?.studies?.treatmentPlan?.notes?.filter((el) => el?.checked)?.length;

        if (amountOfCheckedNotes === 0 && totalAmountOfNotes > 0) {
            return '#F44336';
        }
        if (amountOfCheckedNotes > 0 && amountOfCheckedNotes < totalAmountOfNotes) {
            return '#F26B28';
        }
        if (totalAmountOfNotes > 0 && amountOfCheckedNotes === totalAmountOfNotes) {
            return '#01AF69';
        }
    };

    const medicalNursingPlanButtons = [
        createMainScreenButtons(
            <MainScreenButton
                label={t('Medical Plan')}
                colorType={'notMandatory'}
                onOpen={() => dispatch(openPatientForm('medicalPlan'))}
                filled={!!patient?.studies?.medicalPlan?.when && !!patient?.studies?.medicalPlan?.notes.length}
                value={patient?.studies?.medicalPlan}
                datePath={'when'}
                withNotes
                disabled={disableSave}
            />,
            nurseMedicalPlanAvailable,
        ),
        createMainScreenButtons(
            <MainScreenButton
                label={t('Nursing Plan')}
                colorType={'notMandatory'}
                onOpen={() => dispatch(openPatientForm('nursingPlan'))}
                filled={!!patient?.studies?.nursingPlanNote?.when && !!patient?.studies?.nursingPlanNote?.notes.length}
                value={patient?.studies?.nursingPlanNote}
                withNotes
                disabled={disableSave}
            />,
            nurseMedicalPlanAvailable,
        ),
        createMainScreenButtons(
            <MainScreenButton
                label={t('Treatment Plan')}
                colorType={'notMandatory'}
                customColor
                btnBackground={getTreatmentPlanBtnColor}
                onOpen={() => dispatch(openPatientForm('treatmentPlan'))}
                filled={!!patient?.studies?.treatmentPlan?.when && !!patient?.studies?.treatmentPlan?.notes.length}
                value={patient?.studies?.treatmentPlan}
                datePath={'when'}
                withNotes
                disabled={disableSave}
            />,
            treatmentFormEnabled,
        ),
    ].filter(({display}) => display === true);

    if ((!nurseMedicalPlanAvailable && !treatmentFormEnabled) || patientType === PATIENT_CONTEXT_TYPE.REVIEW) return null;

    return (
        <Grid container spacing={2} style={{margin: '0px'}}>
            <Grid item xs={12} sx={{mt: 1}}>
                <Typography
                    variant="body1"
                    fontWeight="bold"
                    style={{fontSize: '1.2rem', paddingLeft: 10}}
                >
                    {t('Plans')}
                </Typography>

                <Divider/>
            </Grid>

            <div
                style={{
                    display: 'grid',
                    gap: 16,
                    width: '100%',
                    marginLeft: 16,
                    marginTop: 12,
                    gridTemplateColumns: columnCount,
                }}
            >
                {medicalNursingPlanButtons.map((element, index) => {
                    if (!element.display) return null;

                    return (
                        <div key={index} style={{width: '100%'}}>
                            {element.button}
                        </div>
                    );
                })}
            </div>
        </Grid>
    );
};

export default MainScreenTaskButtons;